import { Dayjs } from "utils/dayjs"

import { Guid, Lmid } from "@/types"
import AssetArticle from "./AssetArticle"
import AssetDisplayStatus from "./AssetDisplayStatus"
import RequestLocation from "./RequestLocation"

export interface IShippingOrderAssetExtended {
    assetId: Guid
    lmid: Lmid
    articleThumbnailUri?: string
    articleDescription: string
    altArticleDescription?: string
    articleId: Guid
    startDate?: Dayjs
    endDate?: Dayjs
    isLabeled?: boolean
    departureLocationId?: Guid | null
    homebaseId?: Guid
    arrivalLocationId?: Guid | null
    displayStatus?: AssetDisplayStatus
    releaseDate?: Dayjs | null
    storeDate?: Dayjs | null

    plannedAsset?: AssetArticle
    plannedAssetDisplayStatus?: AssetDisplayStatus
}

export default class ShippingOrderAssetExtended {
    assetId: Guid
    lmid: Lmid
    articleThumbnailUri?: string
    articleDescription: string
    altArticleDescription?: string
    articleId: Guid
    startDate?: Dayjs
    endDate?: Dayjs
    isLabeled: boolean
    departureLocationId?: Guid
    arrivalLocationId?: Guid
    displayStatus?: AssetDisplayStatus
    homebaseId?: Guid
    departureLocation?: RequestLocation
    arrivalLocation?: RequestLocation
    releaseDate?: Dayjs
    storeDate?: Dayjs

    plannedAsset?: AssetArticle
    plannedAssetDisplayStatus?: AssetDisplayStatus

    constructor(data: IShippingOrderAssetExtended, requestLocations: RequestLocation[] | null) {
        this.assetId = data.assetId
        this.lmid = data.lmid
        this.articleThumbnailUri = data.articleThumbnailUri
        this.articleDescription = data.articleDescription
        this.altArticleDescription = data.altArticleDescription
        this.articleId = data.articleId
        this.startDate = data.startDate
        this.endDate = data.endDate
        this.isLabeled = data.isLabeled || false
        this.departureLocationId = data.departureLocationId || undefined
        this.arrivalLocationId = data.arrivalLocationId || undefined
        this.displayStatus = data.displayStatus
        this.homebaseId = data.homebaseId
        this.departureLocation = requestLocations?.find(l => l.id === this.departureLocationId)
        this.arrivalLocation = requestLocations?.find(l => l.id === this.arrivalLocationId)
        this.releaseDate = data.releaseDate || undefined
        this.storeDate = data.storeDate || undefined

        this.plannedAsset = data.plannedAsset
        this.plannedAssetDisplayStatus = data.plannedAssetDisplayStatus
    }
}
